export const headlineWithNumbersLgScreen = '1 / 7';
export const headlineNoNumbersLgScreen = '1 / 9';
export const numbersLgScreen = ' 8 / 13';
export const mediaLgScreen = '1 / 7';
export const descriptionsWithCTALgScreen = '8 / 13';
export const headlineWithNumbersMdScreen = '1 / 7';
export const headlineNoNumbersMdScreen = '1 / 10';
